module.exports = "<p>accesos works!</p>\n"